import React from "react";

const ChartsSection = ({ summary }) => {
    return (
        <section className="card">
            <h3>Charts</h3>
            {/* Placeholder for charts, e.g., using Chart.js or Recharts */}
            <p>Budget: {summary.totalBudget.toLocaleString()}, Spent: {summary.totalSpent.toLocaleString()}</p>
            <p>Balance: {summary.balance.toLocaleString()}, % Used: {summary.utilization}</p>
        </section>
    );
};

export default ChartsSection;